import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-lg-12" }
const _hoisted_3 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_4 = { class: "card-body p-4" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-6" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "position-relative" }
const _hoisted_9 = { class: "text-danger" }
const _hoisted_10 = { class: "col-lg-6" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "position-relative" }
const _hoisted_13 = { class: "text-danger" }
const _hoisted_14 = { class: "col-lg-6" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = { class: "text-danger" }

import { useField, useForm } from "vee-validate";
import { toTypedSchema } from "@vee-validate/zod";
import * as zod from "zod";
import { onMounted, ref } from "vue";
import router from "@/router";
import BaseLoading from "@/components/Common/BaseLoading.vue";
import { toast } from "vue-sonner";
import { useShipManagementCompanyStore } from "@/stores/master/ship-management-company";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { ShipManagementCompanyPayload } from "@/types/interface/ship-management-company";
import { mapOptionMultiselect } from "@/utils/helper";
import { useRegionStore } from "@/stores/master/region";


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateShipManagementCompany',
  setup(__props) {

const idShipManagementCompany = ref<string>("");
const isEdit = ref<boolean>(false);
const isLoading = ref<boolean>(false);
const shipManagementCompanyStore = useShipManagementCompanyStore();
const regionStore = useRegionStore();
const detailShipCompany = ref<any>();
const listCountry = ref([]);

const validationSchema = toTypedSchema(
  zod.object({
    name: zod.string().nonempty({ message: "Name is required" }),
    reg_no: zod
      .string()
      .nonempty({ message: "Registration Number is required" }),
    country: zod.preprocess(
      (val) => (val && typeof val === "object" ? val.value : val),
      zod.number()
    ),
  })
);

const { handleSubmit, errors } = useForm({
  validationSchema,
});

const { value: name } = useField<string>("name");
const { value: reg_no } = useField<string>("reg_no");
const { value: country } = useField<string>("country");

const onSubmit = handleSubmit(async (values) => {
  isLoading.value = true;
  const payloadPosition: ShipManagementCompanyPayload = {
    name: name.value,
    reg_no: reg_no.value,
    country: country.value?.value,
  };

  const responseApi = ref<any>();
  if (isEdit.value == true) {
    responseApi.value = await shipManagementCompanyStore.dispatchUpdate(
      idShipManagementCompany.value,
      payloadPosition
    );
  } else {
    responseApi.value = await shipManagementCompanyStore.dispatchCreate(
      payloadPosition
    );
  }
  const { success, message } = responseApi.value;

  if (success == true) {
    setTimeout(() => {
      isLoading.value = false;
      toast.success(
        isEdit.value
          ? "Ship Management Company Successfully Updated"
          : "Ship Management Company Successfully Added"
      );
      router.push("/master/ship-management-company");
    }, 1000);
  } else {
    isLoading.value = false;
    toast.error(message);
  }
});

const loadDetailShipManagementCompany = async () => {
  const { success, message } = await shipManagementCompanyStore.dispatchDetail(
    idShipManagementCompany.value
  );
  if (success) {
    detailShipCompany.value = await shipManagementCompanyStore.company.data;
    name.value = detailShipCompany.value.name;
    reg_no.value = detailShipCompany.value.reg_no;
    country.value = mapOptionMultiselect(
      detailShipCompany.value.country,
      "id",
      "name"
    );
  }
};

const loadListCountry = async () => {
  const { success } = await regionStore.dispatchGetCountry();
  listCountry.value = mapOptionMultiselect(regionStore.countries, "Id", "Name");
};

onMounted(() => {
  loadListCountry();
  if (router.currentRoute.value.params.id != undefined) {
    isEdit.value = true;
    idShipManagementCompany.value =
      router.currentRoute.value.params.id.toString();
    loadDetailShipManagementCompany();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4" }, [
            _createElementVNode("h3", { class: "mb-0" }, "Form Create Ship Management Company"),
            _createElementVNode("a", {
              class: "btn btn-danger fw-semibold text-white px-3",
              type: "button",
              href: "/master/ship-management-company"
            }, [
              _createElementVNode("i", { class: "ri-arrow-drop-left-line text-gray-light" }),
              _createTextVNode(" Back To List Ship Management Company ")
            ])
          ], -1)),
          (isLoading.value)
            ? (_openBlock(), _createBlock(BaseLoading, {
                key: 0,
                text: "Processing Data..."
              }))
            : _createCommentVNode("", true),
          (!isLoading.value)
            ? (_openBlock(), _createElementBlock("form", {
                key: 1,
                onSubmit: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args))),
                class: "row g-3 needs-validation form"
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _cache[4] || (_cache[4] = _createElementVNode("label", {
                        for: "name",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Name "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_8, [
                        _withDirectives(_createElementVNode("input", {
                          name: "name",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(name) ? (name).value = $event : null)),
                          placeholder: "Name",
                          type: "text",
                          class: "form-control text-dark"
                        }, null, 512), [
                          [_vModelText, _unref(name)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(errors).name), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _cache[5] || (_cache[5] = _createElementVNode("label", {
                        for: "reg_no",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Registration Number "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_12, [
                        _withDirectives(_createElementVNode("input", {
                          name: "reg_no",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(reg_no) ? (reg_no).value = $event : null)),
                          placeholder: "Ship Management Company Name",
                          type: "text",
                          class: "form-control text-dark"
                        }, null, 512), [
                          [_vModelText, _unref(reg_no)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(errors).reg_no), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _cache[6] || (_cache[6] = _createElementVNode("label", {
                        for: "country",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Country "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_unref(vSelect), {
                          modelValue: _unref(country),
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(country) ? (country).value = $event : null)),
                          options: listCountry.value,
                          placeholder: "Choose Country"
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(errors).country), 1)
                    ])
                  ]),
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "col-12 mt-5" }, [
                    _createElementVNode("button", {
                      class: "btn btn-primary fw-semibold text-white py-2 px-3",
                      type: "submit"
                    }, " Save ")
                  ], -1))
                ])
              ], 32))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})